<template>
    <div class="on_mobile_component">

        <div class="modal fade" :class='{"in": isVisible, "open": isVisible}'>
            <div class="modal-dialog" style="width: 80%; max-width: 900px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" @click="closeModal"
                                aria-hidden="true">&times;
                        </button>
                        <h4 class="modal-title">Auch <strong>mobil</strong> ein EntwicklerHeld!?</h4>
                    </div>

                    <div class="modal-body" style="overflow: auto; padding: 1rem;">
                        <div class="row">
                            <div class="col-xs-10 col-xs-offset-1">
                                <img src="/assets/icons/phone-to-laptop.svg" alt="Icon with a mobile and a laptop device"
                                     style="display: block; margin: 1rem auto; max-width: 500px;"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <p class="text-center">Cool, dass du auch auf deinem <strong>mobilen Endgerät</strong>
                                    coden
                                    würdest,
                                    aber momentan ist das leider nur auf dem Desktop möglich :-(
                                </p>
                                <p class="text-center">
                                    <strong>Wechsel doch zum
                                        coden an deinen Desktop, da hast du garantiert mehr Spaß an der
                                        Plattform</strong>!
                                </p>
                        </div>
                            <div class="col-lg-12 text-center">
                                <hr/>
                                <button style="margin-top: 1rem;" class="btn btn-secondary" @click="closeModal">Alles klar!</button>
                            </div>
                             <div class="col-lg-12 text-center" style="margin-top: 3rem; margin-bottom: 2rem;">
                                <a style="text-decoration: underline; font-size: 0.9rem" @click="$emit('jumpToNextTask')">Ich möchte trotzdem loslegen <br>(auf eigene Gefahr)!</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade in" v-if="isVisible"></div>
    </div>
</template>

<script>
    export default {
        name: "OnMobileComponent",
        props: {
            isVisible: {type: [Boolean], default: {}},
            closeHandler: {type: [Function], default: {}},
        },

        data() {
            return {}
        },

        methods: {
            closeModal() {
                this.closeHandler();
            },
        }
    }
</script>

<style scoped>

    .open {
        display: block;
    }

    @media (max-width: 768px) {
        .modal.fade .modal-dialog {
            width: auto !important;
        }
    }
</style>
